var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Establish the root object, `window` in the browser, or `global` on the server.
/* eslint-disable eqeqeq,no-restricted-globals,@typescript-eslint/no-explicit-any */
var root = ((typeof self == 'object' &&
    self.Object == Object &&
    self) ||
    (typeof global == 'object' && global.Object == Object && global));
/* eslint-enable eqeqeq,no-restricted-globals,@typescript-eslint/no-explicit-any */
var window = root.window, document = root.document;
export { window, document };
export function isSSR() {
    return !window || !document || !document.body || !!(window && window.SSR_MODE);
}
export function isIE() {
    return (!isSSR() &&
        (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1));
}
export function isIOS() {
    return !isSSR() && window.CSS && window.CSS.supports('-webkit-overflow-scrolling: touch');
}
export function isSafari() {
    return (!isSSR() &&
        navigator.userAgent.indexOf('Safari') !== -1 &&
        navigator.userAgent.indexOf('Chrome') === -1);
}
export function isFixedStickyPortalWorkaroundEnabled() {
    return isIOS();
}
var originalLocation = window === null || window === void 0 ? void 0 : window.location;
export var mockWindowLocation = function (location) {
    if (!originalLocation || !(window === null || window === void 0 ? void 0 : window.location))
        return;
    var mockedLocation = __assign(__assign(__assign({}, originalLocation), {
        protocol: 'https:',
        pathname: '/book-room/region',
        host: 'www.mgmresorts.com', // https://developer.mozilla.org/en-US/docs/Web/API/Location/host
    }), location);
    window.location = originalLocation;
    Object.defineProperty(window, 'location', { value: mockedLocation });
};
export var mockWindowProperty = function (property, value) {
    if (!window || !value)
        return;
    var mockedProperty = typeof window[property] === 'function' || typeof window[property] !== 'object'
        ? value
        : __assign(__assign({}, window[property]), value);
    delete window[property];
    window[property] = mockedProperty;
    Object.defineProperty(window, property, { value: mockedProperty });
};
export var removeQueryParamFromURI = function (uri, queryParam) {
    return uri.replace(new RegExp("[?&]".concat(queryParam, "=1$|").concat(queryParam, "=1&?"), 'gm'), '');
};
/**
 * Defines whether `addEventListener('event', function, { passive: true })` is supported,
 * If not, you shouldn't pass the third argument, as older browser don't support object there.
 * Code based on https://github.com/WICG/EventListenerOptions/blob/gh-pages/EventListenerOptions.polyfill.js .
 */
// eslint-disable-next-line import/no-mutable-exports
var supportsPassiveEvents = isSSR();
if (!isSSR()) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    document.createElement('div').addEventListener('test', function () { }, {
        get passive() {
            supportsPassiveEvents = true;
            return false;
        },
    });
}
export { supportsPassiveEvents };
